if (!customElements.get('collection-seo-toggle')) {
  class CollectionSeoToggle extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.collection-seo-content__toggle');
      if (!this.toggle) return;

      this.moreLabel = this.querySelector('.collection-seo-content__summary--more');
      this.lessLabel = this.querySelector('.collection-seo-content__summary--less');
      this.text = this.querySelector('.collection-seo-content__text');

      if (this.text && !this.text.id) {
        this.text.id = `${this.toggle.id}-text`;
      }

      const textId = this.text?.id;

      if (textId) {
        this.moreLabel?.setAttribute('aria-controls', textId);
        this.lessLabel?.setAttribute('aria-controls', textId);
      }

      this.syncAria = this.syncAria.bind(this);
      this.toggle.addEventListener('change', this.syncAria);
      this.syncAria();
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('change', this.syncAria);
    }

    syncAria() {
      const expanded = this.toggle.checked;

      this.moreLabel?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      this.lessLabel?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  customElements.define('collection-seo-toggle', CollectionSeoToggle);
}
